import CommercialService from '_services/rest/modules/commercial';

export default {
  state: {
    commercial: null,
    commercialList: null,
  },
  mutations: {
    setCommercialList(state, response) {
      state.commercialList = response;
    },
    setCommercial(state, response) {
      state.commercial = response;
    },
  },
  actions: {
    getCommercialList({ commit }, params) {
      return CommercialService.getList(params)
        .then(response => {
          commit('setCommercialList', response);
        });
    },
    getCommercial({ commit }, params) {
      return CommercialService.getCommercialById(params)
        .then(commercial => {
          commit('setCommercial', commercial);
        })
        .catch(error => {
          throw error.message;
        });
    },
  },
};
